import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import classnames from 'classnames';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { programOptions } from '@/data/staticProgramData';
import { scrollToRegistration } from '@/utils/scrollToSection';
import 'swiper/css';
import 'swiper/css/pagination';

const ProgramOptionCard = ({ option, isSelected, onSelect }) => {
  const handleSelectClick = (e) => {
    e.preventDefault();
    onSelect(option.key);
  };

  const handleRegisterClick = (e) => {
    e.preventDefault();
    onSelect(option.key);
    scrollToRegistration();
  };

  return (
    <FlexContainer
      className={classnames('program-option-card flex-column', {
        'program-option-card--selected': isSelected,
        'program-option-card--featured': option.key === 'company'
      })}
    >
      {option.badge && (
        <span className="program-option-card__badge">{option.badge}</span>
      )}
      
      <div className="program-option-card__header flex-column">
        <i className={classnames('fa-solid', option.icon, 'program-option-card__icon')} aria-hidden="true" />
        <h3 className="program-option-card__title">{option.title}</h3>
        <p className="program-option-card__subtitle">{option.subtitle}</p>
      </div>

      <div className="program-option-card__pricing flex-column align-items-center">
        <span className="program-option-card__price">{option.price}</span>
        <span className="program-option-card__duration">
          <i className="fa-solid fa-clock" aria-hidden="true" /> {option.duration}
        </span>
      </div>

      <ul className="program-option-card__features flex-column">
        {option.features.map((feature, idx) => (
          <li key={idx} className="flex-row align-items-start">
            <i className="fa-solid fa-circle-check" aria-hidden="true" />
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <div className="program-option-card__footer flex-column gap-12 width100">
        <button
          type="button"
          onClick={handleRegisterClick}
          className="program-option-card__buy-btn width100 text-center"
        >
          INSCRIBIRME AHORA <i className="fa-solid fa-cart-shopping" aria-hidden="true" />
        </button>

        <button
          type="button"
          onClick={handleSelectClick}
          className={classnames('program-option-card__select-btn width100', {
            'program-option-card__select-btn--active': isSelected
          })}
        >
          {isSelected ? '✓ Seleccionado' : 'Regístrate aquí para más información'}
        </button>
      </div>
    </FlexContainer>
  );
};

const ProgramOptions = ({ selectedOption, onSelectOption }) => {
  const optionsList = [programOptions.enroll, programOptions.info, programOptions.company];

  return (
    <div className="program-options-wrap">
      {/* Mobile Swiper version */}
      <Swiper
        className="program-options-swiper"
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={20}
        slidesPerView={1.05}
        centeredSlides={true}
        initialSlide={0}
        grabCursor
        breakpoints={{
          480: {
            slidesPerView: 1.15,
            spaceBetween: 20,
            centeredSlides: false
          },
          640: {
            slidesPerView: 1.25,
            spaceBetween: 24,
            centeredSlides: false
          }
        }}
        aria-label="Opciones de especialización del programa"
      >
        {optionsList.map((opt) => (
          <SwiperSlide key={opt.key}>
            <ProgramOptionCard
              option={opt}
              isSelected={selectedOption === opt.key}
              onSelect={onSelectOption}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Desktop Grid version */}
      <div className="program-options-grid">
        {optionsList.map((opt) => (
          <ProgramOptionCard
            key={opt.key}
            option={opt}
            isSelected={selectedOption === opt.key}
            onSelect={onSelectOption}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgramOptions;
